module.exports = __webpack_public_path__ + "img/2.a40b4a1a.jpg";